<template>
  <div class="plan-pricing">
    <h2 class="heading">{{ planDetails.main_title }}</h2>
    <h2 class="price">${{ planDetails?.amount_in_dollars }}</h2>
    <p class="services">
      {{ planDetails.services_per_year }} times / year • Valid for
      {{ planDetails.validity_months }} months
    </p>
    <span v-if="planDetails.saved_amount" class="save-badge">
      Save ${{ planDetails.saved_amount }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'PlanPricingHeader',
  props: {
    planDetails: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.plan-pricing {
  text-align: center;
  margin-bottom: 20px;
}

.price {
  font-size: 32px;
  font-weight: 800;
  background: linear-gradient(135deg, #f46523, #ff9800);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: fadeInUp 0.8s ease-out;
}
.heading {
  font-size: 52px;
  margin-bottom: -10px;

  font-weight: 800;
  background: linear-gradient(135deg, #f46523, #ff9800);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: fadeInUp 0.8s ease-out;
}

.services {
  font-size: 16px;
  color: #64748b;
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

.save-badge {
  display: inline-block;
  background: linear-gradient(135deg, #ffd700, #ff9800);
  color: #1a1a1a;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 700;
  margin-top: 12px;
  font-size: 14px;
  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);
  animation: bounceIn 1s ease-out 0.5s both;
}

@media (max-width: 768px) {
  .price {
    font-size: 20px;
    padding-top: 6px;
  }
  .heading {
    font-size: 24px;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
